import { List } from '@zillow/constellation';
import { propertyUtils } from '@zg-rentals/rental-manager-env';

import { useSelector } from '../../../../selectors/useSelector';

const WizardTipContent = () => {
  const currentProperty = useSelector((state) => state.properties.currentProperty);
  const isRoomForRent = propertyUtils.isRoomForRent({ currentProperty });

  return (
    <div data-testid="WizardTipContent">
      {/* lists have a different left padding */}
      <List paddingLeft="md">
        {isRoomForRent ? (
          <>
            <List.Item>Start with the room’s best features, like a walk-in closet or private entrance.</List.Item>
            <List.Item>
              Include key details about the room. What level is it on? Does it have an attached bathroom? What type of
              flooring does it have? Help renters imagine themselves in the space.
            </List.Item>
            <List.Item>
              Avoid generic words (like “nice” and “beautiful”). Instead, use descriptive words: “spacious,” “airy,”
              “newly renovated,” etc.
            </List.Item>
          </>
        ) : (
          <>
            <List.Item>
              Market the property’s proximity to transit, dining, shopping, and other local attractions
            </List.Item>
            <List.Item>Mention upgrades, attractive amenities, and other appealing details</List.Item>
            <List.Item>Indicate whether you live on-site</List.Item>
          </>
        )}
      </List>
    </div>
  );
};

export default WizardTipContent;
